import { type UseMediaQueryOptions, useMediaQuery, useTheme } from '@mui/material';

const options: UseMediaQueryOptions = {
  noSsr: true,
};

export const deviceBreakpoints = {
  mobile: 0,
  tablet: 472,
  laptop: 720,
  desktop: 1200,
};

export function useIsDesktop(): boolean {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.up(deviceBreakpoints.desktop), options);
}

export function useIsLaptopOrLower(): boolean {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down(deviceBreakpoints.desktop), options);
}

export function useIsTabletOrLower(): boolean {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down(deviceBreakpoints.laptop), options);
}

export function useIsMobile(): boolean {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down(deviceBreakpoints.tablet), options);
}
